import React from "react";
import { Routes, Route } from "react-router-dom";
import "./App.css";
import Layout from "./components/layout/Layout";
import Home from "./pages/Home";
import WhatIsBhajanJamming from "./pages/WhatIsBhajanJamming";
import Delhi from "./pages/Delhi";
import Gurgaon from "./pages/Gurgaon";
import Chandigarh from "./pages/Chandigarh";
import Editions from "./pages/Editions";
import EditionDetail from "./pages/EditionDetail";
import VoicesPage from "./pages/VoicesPage";
import GalleryPage from "./pages/GalleryPage";
import FaqPage from "./pages/FaqPage";
import KashiWithAnshu from "./pages/KashiWithAnshu";
import MediaCoverage from "./pages/MediaCoverage";
import Contact from "./pages/Contact";
import Perform from "./pages/Perform";
import HostAntara from "./pages/HostAntara";
import Sponsorship from "./pages/Sponsorship";
import NotFound from "./pages/NotFound";
import ArchiveRoute, { ARCHIVE_PATHS } from "./pages/archiveRoute";

export default function App() {
  return (
    <Routes>
      <Route element={<Layout />}>
        <Route path="/" element={<Home />} />
        <Route path="/what-is-bhajan-jamming" element={<WhatIsBhajanJamming />} />
        <Route path="/delhi" element={<Delhi />} />
        <Route path="/gurgaon" element={<Gurgaon />} />
        <Route path="/chandigarh" element={<Chandigarh />} />
        <Route path="/editions" element={<Editions />} />
        <Route path="/editions/:slug" element={<EditionDetail />} />
        <Route path="/voices" element={<VoicesPage />} />
        <Route path="/gallery" element={<GalleryPage />} />
        {ARCHIVE_PATHS.map((p) => (
          <Route key={p} path={p} element={<ArchiveRoute path={p} />} />
        ))}
        <Route path="/faq" element={<FaqPage />} />
        <Route path="/kashi-with-anshu" element={<KashiWithAnshu />} />
        <Route path="/media-coverage" element={<MediaCoverage />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/perform" element={<Perform />} />
        <Route path="/host" element={<HostAntara />} />
        <Route path="/sponsorship" element={<Sponsorship />} />
        <Route path="*" element={<NotFound />} />
      </Route>
    </Routes>
  );
}
